<template>
  <div class="panel-heading" role="tab" :id="id">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "collapse-header",
  props: {
    id: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Collapse/CollapseHeader.vue